import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
const Footer = ()=>{
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-gray-800 px-8 py-12 text-center text-white",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-7xl",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-2 text-2xl font-bold",
                    style: {
                        fontFamily: "'Caveat', cursive"
                    },
                    children: "Histotime"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-6 opacity-80",
                    children: "不定期に起きることを、時間で残す記録アプリ"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-6 flex flex-wrap justify-center gap-4 text-sm opacity-70",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/releases",
                            className: "transition-opacity hover:opacity-100",
                            children: "更新履歴"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/terms",
                            className: "transition-opacity hover:opacity-100",
                            children: "利用規約"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/privacy",
                            className: "transition-opacity hover:opacity-100",
                            children: "プライバシーポリシー"
                        }),
                        /*#__PURE__*/ _jsx("a", {
                            href: "https://forms.gle/dMJabgnM6nxMAkYH8",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "transition-opacity hover:opacity-100",
                            children: "お問い合わせ"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text-sm opacity-70",
                    children: [
                        "© ",
                        new Date().getFullYear(),
                        " ITSolutionZ Inc. All rights reserved."
                    ]
                })
            ]
        })
    });
};
export default Footer;
